/* NĒM cookie consent. Ported from the WordPress build: same banner, same
   "what is a cookie" modal, same 30-day first-party cookie. */
(function () {
  'use strict';

  var popup = document.getElementById('oxy-cookie-popup');
  var closeBtn = document.getElementById('oxy-cookie-close');
  var acceptBtn = document.getElementById('oxy-cookie-accept');
  var rejectBtn = document.getElementById('oxy-cookie-reject');
  var modalOverlay = document.getElementById('oxy-cookie-modal-overlay');
  var modalCloseX = document.getElementById('oxy-cookie-modal-x');
  var modalOk = document.getElementById('oxy-cookie-modal-ok');
  var whatBtn = document.getElementById('oxy-cookie-what');

  if (!popup || !acceptBtn || !rejectBtn) return;

  var COOKIE_NAME = 'oxyvape_cookie_consent';
  var COOKIE_DAYS = 30;

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie =
      name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var prefix = name + '=';
    var parts = decodeURIComponent(document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return part.substring(prefix.length);
    }
    return '';
  }

  function hidePopup() {
    popup.classList.remove('oxy-cookie-show');
    popup.style.display = 'none';
  }

  function saveChoice(value) {
    setCookie(COOKIE_NAME, value, COOKIE_DAYS);
    hidePopup();
    document.dispatchEvent(
      new CustomEvent('oxyvape:cookie-consent', { detail: { choice: value } })
    );
  }

  function openModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.add('oxy-modal-show');
    modalOverlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (modalOk) {
      window.setTimeout(function () {
        modalOk.focus({ preventScroll: true });
      }, 50);
    }
  }

  function closeModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.remove('oxy-modal-show');
    modalOverlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (whatBtn) {
      window.setTimeout(function () {
        whatBtn.focus({ preventScroll: true });
      }, 50);
    }
  }

  if (!getCookie(COOKIE_NAME)) {
    window.setTimeout(function () {
      popup.classList.add('oxy-cookie-show');
      popup.style.display = '';
    }, 700);
  } else {
    hidePopup();
  }

  acceptBtn.addEventListener('click', function () {
    saveChoice('accepted');
  });

  rejectBtn.addEventListener('click', function () {
    saveChoice('rejected');
  });

  function activate(el, handler) {
    if (!el) return;
    el.addEventListener('click', handler);
    el.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handler();
      }
    });
  }

  activate(closeBtn, function () {
    saveChoice('closed');
  });
  activate(whatBtn, openModal);

  if (modalOk) modalOk.addEventListener('click', closeModal);
  if (modalCloseX) modalCloseX.addEventListener('click', closeModal);

  if (modalOverlay) {
    modalOverlay.addEventListener('click', function (event) {
      if (event.target === modalOverlay) closeModal();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      modalOverlay &&
      modalOverlay.classList.contains('oxy-modal-show')
    ) {
      closeModal();
    }
  });
})();
